import { Box } from '@material-ui/core';
import styled from 'styled-components';

export const UiSideBarFloat = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2.5),
}));
